module.exports = __webpack_public_path__ + "static/media/heart9.c8bf7e0e.png";